module.exports = __webpack_public_path__ + "media/components/country-flag/static/lr-fe09ed3f6c34e8c1ef12ea871e4465c3.svg";